import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Package, Image as ImageIcon, MessageSquare, LogOut, FileText, Briefcase, HelpCircle } from "lucide-react";
import logoWebp from "../assets/tamari-logo.webp";
import logoPng from "../assets/tamari-logo.png";

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
    { to: "/admin/site-content", label: "Përmbajtja", icon: FileText },
    { to: "/admin/services", label: "Shërbimet", icon: Briefcase },
    { to: "/admin/products", label: "Produktet", icon: Package },
    { to: "/admin/gallery", label: "Galeria", icon: ImageIcon },
    { to: "/admin/faqs", label: "FAQ", icon: HelpCircle },
    { to: "/admin/contacts", label: "Kontaktet", icon: MessageSquare },
  ];

  const isActive = (link) => link.exact ? location.pathname === link.to : location.pathname.startsWith(link.to);

  return (
    <div className="min-h-screen bg-zinc-50 flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-zinc-200 flex flex-col fixed left-0 top-0 bottom-0">
        <div className="p-6 border-b border-zinc-200">
          <Link to="/" className="flex items-center">
            <picture>
              <source srcSet={logoWebp} type="image/webp" />
              <img src={logoPng} alt="Tamari" loading="eager" className="h-10 w-auto" />
            </picture>
          </Link>
          <p className="text-xs text-zinc-500 mt-2 uppercase tracking-wider font-bold">Admin Panel</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {links.map((link) => {
            const Icon = link.icon;
            const active = isActive(link);
            return (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`admin-nav-${link.to.split("/").pop() || "dashboard"}`}
                className={`flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${
                  active ? "bg-[#0A0A0A] text-white" : "text-zinc-700 hover:bg-zinc-100"
                }`}
              >
                <Icon className="w-4 h-4" />
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-zinc-200">
          <p className="text-xs text-zinc-500 mb-2">Logged in si:</p>
          <p className="text-sm font-medium text-[#0A0A0A] mb-3 truncate">{user?.email}</p>
          <button
            data-testid="admin-logout-button"
            onClick={logout}
            className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Dil
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-64 p-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
